import {PayloadAction} from "@reduxjs/toolkit";
import {all, call, put, takeLatest} from "redux-saga/effects";
import {
  MessageTemplateApiMessageTemplateCreateRequest,
  MessageTemplateApiMessageTemplateCreateResponse,
  MessageTemplateApiMessageTemplateDeleteRequest,
  MessageTemplateApiMessageTemplateDeleteResponse,
  MessageTemplateApiMessageTemplateListRequest,
  MessageTemplateApiMessageTemplateListResponse,
  MessageTemplateApiMessageTemplateUpdateRequest,
  MessageTemplateApiMessageTemplateUpdateResponse,
  PageModel
} from "../../../proto/generated/api_entities_pb";
import {API} from "../../../API/API";
import {getErrorMessageByCode} from "../../../utils/constans/errorCodes/errorCodes";
import {PageModelLimits} from "../../../utils/constans/pagination/pageModelLimits";
import {
  ICreateMessageTemplatePayload,
  IDeleteMessageTemplatePayload,
  IGetMessageTemplateListPayload,
  IUpdateMessageTemplatePayload
} from "../../reducers/messageTemplatesReducer/messageTemplatesReducerTypes";
import {
  createMessageTemplate,
  deleteMessageTemplate,
  getMessageTemplateList,
  setCreateMessageTemplateResult,
  setDeleteMessageTemplateResult,
  setMessageTemplateListResult,
  setUpdateMessageTemplateResult,
  updateMessageTemplate
} from "../../reducers/messageTemplatesReducer/messageTemplatesReducer";

function* getMessageTemplateListSaga({payload}: PayloadAction<IGetMessageTemplateListPayload>) {
  const req = new MessageTemplateApiMessageTemplateListRequest()
    .setPagemodel(
      new PageModel()
        .setPage(payload.page)
        .setLimit(payload.limit || PageModelLimits.Notifications)
    );

  if (payload.name) {
    req.setName(payload.name);
  }

  try {
    const res: MessageTemplateApiMessageTemplateListResponse = yield call(API.messageTemplateList, req);

    yield put(setMessageTemplateListResult({
      items: res.getMessagetemplatesList(),
      totalCount: res.getTotalcount(),
    }));
  } catch {
  }
}

function* createMessageTemplateSaga({payload}: PayloadAction<ICreateMessageTemplatePayload>) {
  const req = new MessageTemplateApiMessageTemplateCreateRequest()
    .setName(payload.name)
    .setText(payload.text);

  try {
    const res: MessageTemplateApiMessageTemplateCreateResponse = yield call(API.messageTemplateCreate, req);

    if (res.getResultresponse()?.getIssuccessful()) {
      yield put(setCreateMessageTemplateResult({
        item: res.getMessagetemplate(),
      }));
    } else {
      yield put(setCreateMessageTemplateResult({
        errorMessage: getErrorMessageByCode(res.getResultresponse()?.getErrormessage()),
      }));
    }
  } catch {
  }
}

function* updateMessageTemplateSaga({payload}: PayloadAction<IUpdateMessageTemplatePayload>) {
  const req = new MessageTemplateApiMessageTemplateUpdateRequest()
    .setMessagetemplateid(payload.messageTemplateId)
    .setName(payload.name)
    .setText(payload.text);

  try {
    const res: MessageTemplateApiMessageTemplateUpdateResponse = yield call(API.messageTemplateUpdate, req);

    if (res.getResultresponse()?.getIssuccessful()) {
      yield put(setUpdateMessageTemplateResult({
        item: res.getMessagetemplate(),
      }));
    } else {
      yield put(setUpdateMessageTemplateResult({
        errorMessage: getErrorMessageByCode(res.getResultresponse()?.getErrormessage()),
      }));
    }
  } catch {
  }
}

function* deleteMessageTemplateSaga({payload}: PayloadAction<IDeleteMessageTemplatePayload>) {
  const req = new MessageTemplateApiMessageTemplateDeleteRequest()
    .setMessagetemplateid(payload.messageTemplateId);

  try {
    const res: MessageTemplateApiMessageTemplateDeleteResponse = yield call(API.messageTemplateDelete, req);

    if (res.getResultresponse()?.getIssuccessful()) {
      yield put(setDeleteMessageTemplateResult({
        itemId: payload.messageTemplateId,
      }));
    } else {
      yield put(setDeleteMessageTemplateResult({
        errorMessage: getErrorMessageByCode(res.getResultresponse()?.getErrormessage()),
      }));
    }
  } catch {
  }
}

export function* messageTemplatesSaga() {
  yield all([
    takeLatest(getMessageTemplateList.type, getMessageTemplateListSaga),
    takeLatest(createMessageTemplate.type, createMessageTemplateSaga),
    takeLatest(updateMessageTemplate.type, updateMessageTemplateSaga),
    takeLatest(deleteMessageTemplate.type, deleteMessageTemplateSaga),
  ])
}

